var mcb = mcb || {};

mcb.tooltip =
  mcb.tooltip ||
  new (function () {
    this.init = function () {
      //Initialize bootstrap tooltips
      const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
      const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));
    };
  })();
